import React from "react";
import { AdminSuiteActionsProps } from "./AdminSuiteRequestsActions";
import AdminSuiteEmailConfirmation from "./AdminSuiteEmailConfirmation";

const AdminSuiteConfirmationEmail = ({ ...props }: AdminSuiteActionsProps) => {
  return <AdminSuiteEmailConfirmation {...props} />;
};

export default AdminSuiteConfirmationEmail;
